export function filterObject<V>(
  obj: Record<string, V>,
  filterFn: (value: V, key: string, obj: Record<string, V>) => boolean,
) {
  Object.keys(obj).forEach(
    (key) => !filterFn(obj[key], key, obj) && delete obj[key],
  );
  return obj;
}

export function reduceObject<V, R>(
  obj: Record<string, V>,
  reduceFn: (acc: R, value: V, key: string, obj: Record<string, V>) => R,
  defaultValue: R,
) {
  return Object.keys(obj).reduce((acc, key) => {
    const value = obj[key];
    return reduceFn(acc, value, key, obj);
  }, defaultValue);
}

export function immutableFilterObject<V>(
  obj: Record<string, V>,
  filterFn: (value: V, key: string, obj: Record<string, V>) => boolean,
) {
  const copy = { ...obj };
  Object.keys(obj).forEach(
    (key) => !filterFn(copy[key], key, obj) && delete copy[key],
  );
  return copy;
}

export const mapObjectToArray = <
  Value = any,
  Key extends string = string,
  ReturnValue = any,
>(
  object: Record<Key, Value>,
  callback: (value: Value, key: Key, index: number) => ReturnValue,
) => {
  return Object.keys(object).map((key, index) => {
    return callback(object[key as Key], key as Key, index);
  });
};

export const mapObject = <
  Key extends string = string,
  Value = any,
  ReturnValue = any,
>(
  object: Record<Key, Value>,
  callback: (value: Value, key: Key, index: number) => ReturnValue,
) => {
  return (Object.keys(object) as Key[]).reduce(
    (acc, key: Key, index) => {
      const value = object[key];
      return {
        ...acc,
        [key]: callback(value, key, index),
      };
    },
    {} as Record<Key, ReturnValue>,
  );
};

export const isObject = (obj: any) => {
  return obj !== null && typeof obj === "object";
};
export const isPlainObject = (value: any) => {
  return value && [undefined, Object].includes(value.constructor);
};
